<template>
  <layout>
    <router-view />
  </layout>
</template>

<script>
import layout from '../components/common/layout.vue'
export default {
  components: { layout }
}
</script>

<style>

</style>
